import React, { useState } from 'react';

import { OuterWrapper, ToggleItem, Wrapper } from './styles';

export interface Props {
  items: [string, string];
  activeItem: string;
  onSelect: () => void;
}

const MegaToggle = ({ items, activeItem, onSelect }: Props) => {
  const [leftActive, setLeftActive] = useState(items[0] == activeItem);

  const handleClick = () => {
    setLeftActive(!leftActive);
    setTimeout(() => {
      onSelect();
    }, 200);
  };

  return (
    <OuterWrapper>
      <Wrapper leftActive={leftActive}>
        {items.map((el) => (
          <ToggleItem key={el} leftActive={leftActive} onClick={handleClick}>
            {el}
          </ToggleItem>
        ))}
      </Wrapper>
    </OuterWrapper>
  );
};

export default MegaToggle;
